import * as React from "react";
import styled, { css } from "styled-components";
import useLocation from "routing/useLocation";
import { Link, LinkContainer } from "components/common";
import AppConfig from "util/AppConfig";
import { Navbar, Nav } from "components/bootstrap";
import GlobalThroughput from "components/throughput/GlobalThroughput";
import Routes from "routing/Routes";
import BrandNavLogo from "components/navigation/NavigationBrand";
import usePluginEntities from "hooks/usePluginEntities";
import MainNavbar from "components/navigation/MainNavbar";
import { FEATURE_FLAG } from "components/quick-jump/Constants";
import { NAV_ITEM_HEIGHT } from "theme/constants";
import UserMenu from "./UserMenu";
import HelpMenu from "./HelpMenu";
import NotificationBadge from "./NotificationBadge";
import DevelopmentHeaderBadge from "./DevelopmentHeaderBadge";
import InactiveNavItem from "./InactiveNavItem";
import ScratchpadToggle from "./ScratchpadToggle";
import StyledNavbar from "./Navigation.styles";
import { QuickJumpModalContainer } from "../quick-jump";
const BrandLink = styled(Link)(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    min-height: ${NAV_ITEM_HEIGHT};
    color: ${theme.colors.text.primary};

    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.text.primary};
    }
  `
);
const Navigation = React.memo(({ pathname }) => {
  const pluginItems = usePluginEntities("navigationItems");
  return /* @__PURE__ */ React.createElement(StyledNavbar, { fluid: true, fixedTop: true, collapseOnSelect: true }, /* @__PURE__ */ React.createElement(Navbar.Header, null, /* @__PURE__ */ React.createElement(Navbar.Brand, null, /* @__PURE__ */ React.createElement(BrandLink, { to: Routes.WELCOME, "aria-label": "Welcome" }, /* @__PURE__ */ React.createElement(BrandNavLogo, null))), /* @__PURE__ */ React.createElement(Navbar.Toggle, null), /* @__PURE__ */ React.createElement(DevelopmentHeaderBadge, { smallScreen: true }), pluginItems.map(({ key, component: Item }) => /* @__PURE__ */ React.createElement(Item, { key, smallScreen: true }))), /* @__PURE__ */ React.createElement(Navbar.Collapse, null, /* @__PURE__ */ React.createElement(MainNavbar, { pathname }), /* @__PURE__ */ React.createElement(NotificationBadge, null), /* @__PURE__ */ React.createElement(Nav, { pullRight: true, className: "header-meta-nav" }, AppConfig.isFeatureEnabled(FEATURE_FLAG) ? /* @__PURE__ */ React.createElement(QuickJumpModalContainer, null) : null, AppConfig.isCloud() ? /* @__PURE__ */ React.createElement(GlobalThroughput, { disabled: true }) : /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.CLUSTER.NODES }, /* @__PURE__ */ React.createElement(GlobalThroughput, null)), /* @__PURE__ */ React.createElement(InactiveNavItem, { className: "dev-badge-wrap" }, /* @__PURE__ */ React.createElement(DevelopmentHeaderBadge, null), pluginItems.map(({ key, component: Item }) => /* @__PURE__ */ React.createElement(Item, { key }))), /* @__PURE__ */ React.createElement(ScratchpadToggle, null), /* @__PURE__ */ React.createElement(HelpMenu, null), /* @__PURE__ */ React.createElement(UserMenu, null))));
});
const NavigationContainer = () => {
  const { pathname } = useLocation();
  return /* @__PURE__ */ React.createElement(Navigation, { pathname });
};
export default NavigationContainer;
